/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './ForgotPasswordSuccess.style';

import LazyLoginMain from 'src/shared/app/authentication/component/login/LazyLoginMain';
import messages from 'src/shared/app/authentication/l10n/forgotPasswordL10n';
import SuccessBanner from 'src/shared/app/base/component/notification/SuccessBanner';
import SecondaryTopBar from 'src/shared/app/base/component/template/component/SecondaryTopBar';
import useRoutes from 'src/shared/app/base/route/hook/useRoutes';
import { loginRoute } from 'src/shared/app/base/route/setting/routeSettings';
import LinkWithChevron from 'src/shared/ui/component/link/LinkWithChevron';
import InstructionText from 'src/shared/ui/component/text/InstructionText';

type Props = {
  username?: string,
};

const useStyles = createUseStyles(styles);

const ForgotPasswordSucessDumb = ({ username }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const intl = useIntl();
  const [loginPath] = useRoutes(loginRoute);

  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onLogInMouseOver = () => LazyLoginMain.preload();

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <div className={classes.root}>
      <SecondaryTopBar>
        <SuccessBanner
          text={intl.formatMessage(messages.success, { email: username })}
        />
      </SecondaryTopBar>
      <InstructionText>
        {intl.formatMessage(messages.logInHint)}
      </InstructionText>
      <div className={classes.action}>
        <LinkWithChevron href={loginPath} handleMouseOver={onLogInMouseOver}>
          {intl.formatMessage(messages.logInLink)}
        </LinkWithChevron>
      </div>
    </div>
  );
};
export default compose(React.memo)(ForgotPasswordSucessDumb);
